import styled, { css } from 'styled-components';
import { IInternalRegulationObligationRuleReviewStatus } from '../../../graphql/generated';

const getStatusColor = (status?: IInternalRegulationObligationRuleReviewStatus | null, theme?: any) => {
  if (!theme) return 'transparent';

  switch (status) {
    case IInternalRegulationObligationRuleReviewStatus.ToReview:
      return theme.colors.accent2.getValue(700).main;
    case IInternalRegulationObligationRuleReviewStatus.Reviewed:
      return theme.colors.success.getValue(700).main;
    default:
      return 'transparent';
  }
};

export const RuleItemBox = styled.div<{
  isActive: boolean;
  reviewStatus?: IInternalRegulationObligationRuleReviewStatus | null;
}>`
  position: relative;
  display: flex;
  align-items: center;
  gap: ${(p) => p.theme.spacing.getSize(3)};
  padding: ${(p) => p.theme.spacing.getSize(3)};
  padding-left: ${(p) => p.theme.spacing.getSize(4)};
  border: 1px solid ${(p) => p.theme.colors.borders.getValue(1)};
  border-radius: ${(p) => p.theme.spacing.borderRadius};
  box-sizing: border-box;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background-color: ${(p) => getStatusColor(p.reviewStatus, p.theme)};
  }

  ${(p) =>
    p.isActive &&
    css`
      background: ${p.theme.colors.primary.getValue(100).main};
      border-color: ${p.theme.colors.primary.getValue(700).main};
    `}
`;

export const Name = styled.span`
  font-size: ${(p) => p.theme.type.getSize(0)};
  line-height: 1.5;
  word-break: break-word;
  flex: 1;
`;

export const DeleteButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: auto;
`;
